import { useLingui } from "@lingui/react/macro";
import type { LabelFieldKey } from "@/types/label-template";

/**
 * Field names, translated.
 *
 * The API sends an English `label` alongside each key, but it is there for
 * Swagger and for scripts. The UI translates from the key so a French kitchen
 * gets a French label rather than the API's copy of the English one.
 */
export function useLabelFieldNames(): Record<LabelFieldKey, string> {
  const { t } = useLingui();
  return {
    RECIPE_NAME: t`Recipe name`,
    PREP_DATE: t`Prep date`,
    USE_BY: t`Use by`,
    ALLERGENS: t`Allergens`,
    STORAGE_METHOD: t`Storage method`,
    PREPARED_BY: t`Prepared by`,
    BATCH_ID: t`Batch ID`,
    CONTAINER_FLAG: t`Container flag`,
  };
}
